<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Payment-Claim",
  path: "payment/claim",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
